export const APP_NAMESPACE = 'landing-about-portal-front';
